import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LockOutlined } from '@ant-design/icons';

import FormCard from '../../../../components/FormCard';
import Button from '../../../../components/Button';
import { isEncryptedFormat, tryFormatJson } from '../../../../utils/logAuditoria';

// ============================================================================
// Painel exibindo um body (request ou response) de um log de auditoria.
// Se o body cru (wire) for diferente do decoded — caso Santander encrypted —
// renderiza um toggle [Decoded | Wire]. Caso contrario, mostra so o decoded.
// ============================================================================

const LogBodyPanel = ({ titulo, bodyDecoded, bodyWire, format }) => {
  const theme = useTheme();
  const wireDiffereDecoded =
    bodyWire !== null &&
    bodyWire !== undefined &&
    bodyWire !== '' &&
    tryFormatJson(bodyDecoded) !== String(bodyWire);

  const [view, setView] = useState('decoded');
  const showToggle = wireDiffereDecoded;
  const encrypted = isEncryptedFormat(format);

  const conteudoExibido =
    showToggle && view === 'wire' ? String(bodyWire) : tryFormatJson(bodyDecoded);

  return (
    <FormCard
      title={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Typography variant="subtitle1">{titulo}</Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            {format && (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  px: 1,
                  py: 0.25,
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  borderRadius: 0.5,
                  border: '1px solid',
                  borderColor: encrypted
                    ? theme.palette.warning.light
                    : theme.palette.divider,
                  color: encrypted
                    ? theme.palette.warning.darker
                    : theme.palette.text.secondary,
                  backgroundColor: encrypted
                    ? theme.palette.warning.lighter
                    : 'transparent'
                }}
              >
                {encrypted && <LockOutlined style={{ fontSize: 11 }} />}
                {format}
              </Box>
            )}
            {showToggle && (
              <Stack direction="row" spacing={0}>
                <Button
                  size="small"
                  variant={view === 'decoded' ? 'contained' : 'outlined'}
                  color={view === 'decoded' ? 'primary' : 'secondary'}
                  onClick={() => setView('decoded')}
                  sx={{
                    minWidth: 0,
                    px: 1.25,
                    py: 0.25,
                    fontSize: '0.72rem',
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0
                  }}
                >
                  Decoded
                </Button>
                <Button
                  size="small"
                  variant={view === 'wire' ? 'contained' : 'outlined'}
                  color={view === 'wire' ? 'primary' : 'secondary'}
                  onClick={() => setView('wire')}
                  sx={{
                    minWidth: 0,
                    px: 1.25,
                    py: 0.25,
                    fontSize: '0.72rem',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    marginLeft: '-1px'
                  }}
                >
                  Wire
                </Button>
              </Stack>
            )}
          </Stack>
        </Stack>
      }
      border
      contentSX={{ p: 0 }}
    >
      <Box
        component="pre"
        sx={{
          minHeight: 160,
          maxHeight: 320,
          overflow: 'auto',
          p: 2,
          m: 0,
          fontSize: '0.75rem',
          fontFamily:
            'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.default
        }}
      >
        {conteudoExibido || (
          <Box component="span" sx={{ color: theme.palette.text.disabled, fontStyle: 'italic' }}>
            (vazio)
          </Box>
        )}
      </Box>
    </FormCard>
  );
};

export default LogBodyPanel;
